(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3090],{

/***/ 24292:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jewellery/category/[category]",
      function () {
        return __webpack_require__(90176);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ banner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/store/slices/category.ts
var category = __webpack_require__(10328);
// EXTERNAL MODULE: ./src/components/category/banner/banner.module.scss
var banner_module = __webpack_require__(13291);
var banner_module_default = /*#__PURE__*/__webpack_require__.n(banner_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/assets/images/banner_bottom.png
/* harmony default export */ var banner_bottom = ({"src":"/_next/static/media/banner_bottom.929a2aab.png","height":277,"width":1402,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAABlBMVEUUNFYhPl8Eecy1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAEUlEQVQImWNgYGBgZGRgYAAAABIAA12bcnwAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/assets/images/love23.png
/* harmony default export */ var love23 = ({"src":"/_next/static/media/love23.18b49aaa.png","height":383,"width":434,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAMFBMVEWfER39BwlhEifwJzH/AADvRE/EnnbvTVi91c/vQk3XiYvHxrzwUFnYdHryWGLxVV/91LO3AAAAD3RSTlMBOBFXHJschGSme5eEl+qhSad0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVQImUXLtwEAIAzAMKfRIf9/ywbaBc+KiG7AycysoGObmTjSpjsiUIqq/sIFHXQA0ECPMZsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/assets/images/offer.png
/* harmony default export */ var offer = ({"src":"/_next/static/media/offer.d2e3cf79.png","height":382,"width":966,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAABlBMVEURMVMUME8KHjjVAAAAAnRSTlMXCpPFoLAAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAWSURBVAiZY2BgYGAEY0YGRkYGMIYCAACIAAiSFSKiAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
;// CONCATENATED MODULE: ./src/components/category/banner/banner.tsx









var CatgeoryBanner = function() {
    var ref;
    var categoryState = (0,es/* useSelector */.v9)(category/* selectCategory */.uY);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!((ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.banner_image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (banner_module_default()).banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: categoryState.data.banner_image,
                    alt: categoryState.data.title,
                    layout: "fill",
                    objectFit: "cover",
                    unoptimized: true,
                    priority: true
                })
            }),
             false && /*#__PURE__*/ 0
        ]
    });
};
/* harmony default export */ var banner = (CatgeoryBanner);


/***/ }),

/***/ 49515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_not_found; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/svg/404.svg
/* harmony default export */ var _404 = ({"src":"/_next/static/media/404.d5405216.svg","height":369,"width":745});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/common/page-not-found/page-not-found.tsx




var PageNotFound = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            width: "40%",
            margin: "60px auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: _404,
            alt: ""
        })
    });
};
/* harmony default export */ var page_not_found = (PageNotFound);


/***/ }),

/***/ 90176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_category_banner_banner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76051);
/* harmony import */ var _components_common_page_not_found_page_not_found__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49515);
/* harmony import */ var _layout_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70081);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89936);
/* harmony import */ var _store_slices_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40034);
/* harmony import */ var _store_slices_category__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10328);
/* harmony import */ var _styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79356);
/* harmony import */ var _styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9473);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80008);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_category_wizzy_filters_filters__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73839);
/* harmony import */ var _components_category_wizzy_products_list_products_list__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17751);
/* harmony import */ var _lib_syte__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68320);














var Category = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var categoryState = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(_store_slices_category__WEBPACK_IMPORTED_MODULE_6__/* .selectCategory */ .uY);
    var dispatch = (0,_store__WEBPACK_IMPORTED_MODULE_4__/* .useAppDispatch */ .T)();
    var authState = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(_store_slices_auth__WEBPACK_IMPORTED_MODULE_5__/* .selectAuth */ .Hz);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        var timer = setTimeout(function() {
            var ref;
            if (!authState.isModalOpen && ((ref = categoryState.data) === null || ref === void 0 ? void 0 : ref.slug) === "satya-prem-ki-katha") {
                moment_timezone__WEBPACK_IMPORTED_MODULE_9___default().tz.setDefault("Asia/Kolkata");
                var currentDate = moment_timezone__WEBPACK_IMPORTED_MODULE_9___default()();
                var endDate = moment_timezone__WEBPACK_IMPORTED_MODULE_9___default()("2023-06-28", "YYYY-MM-DD").endOf("day");
                if (currentDate.isSameOrBefore(endDate)) {
                // dispatch(authActions.setIsOfferModalOpen(true));
                }
            }
        }, 6000);
        if (!authState.isUserLoading) {
            var ref;
            (0,_lib_syte__WEBPACK_IMPORTED_MODULE_12__/* .syteTrackEvent */ .l)({
                name: "fe_page_view",
                tag: "ecommerce",
                osh_id: (ref = authState.user) === null || ref === void 0 ? void 0 : ref.uuid
            });
        }
        return function() {
            return clearTimeout(timer);
        };
    }, [
        authState.isModalOpen,
        authState.isUserLoading,
        (ref = authState.user) === null || ref === void 0 ? void 0 : ref.uuid,
        (ref1 = categoryState.data) === null || ref1 === void 0 ? void 0 : ref1.slug,
        dispatch, 
    ]);
    if (!categoryState.data) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_page_not_found_page_not_found__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_category_banner_banner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().heading_list_page),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                        className: "",
                        children: [
                            (ref2 = categoryState.data) === null || ref2 === void 0 ? void 0 : ref2.title,
                            ((ref3 = categoryState.data) === null || ref3 === void 0 ? void 0 : ref3.title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    color: "#7f7f7f"
                                },
                                children: "|"
                            }),
                            !!((ref4 = categoryState.products) === null || ref4 === void 0 ? void 0 : ref4.total) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                style: {
                                    color: "#7f7f7f",
                                    fontSize: "1.3rem",
                                    paddingLeft: "8px"
                                },
                                children: [
                                    (ref5 = categoryState.products) === null || ref5 === void 0 ? void 0 : ref5.total,
                                    " Designs"
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "d-none",
                children: (ref6 = categoryState.data) === null || ref6 === void 0 ? void 0 : ref6.slug
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_product_list_module_scss__WEBPACK_IMPORTED_MODULE_13___default().product_section),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_category_wizzy_filters_filters__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_category_wizzy_products_list_products_list__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
Category.getLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Category);


/***/ }),

/***/ 13291:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__nzF5h","banner_bottom_main":"banner_banner_bottom_main__bYXJd","banner_bottom_container":"banner_banner_bottom_container__g9Gsx","banner_bottom_c":"banner_banner_bottom_c__S3asc","love_day":"banner_love_day__HEW6y","discount_image":"banner_discount_image__PpSSM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,8523,4766,2678,959,1387,9082,1246,3623,3564,3278,4071,7715,9774,2888,179], function() { return __webpack_exec__(24292); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);